import {cursorMove} from "./cursor/ufocursor.js"

cursorMove();